module.exports = __webpack_public_path__ + "img/vector.3b8c0d4.svg";